import { useState } from "react";
import { HollowedButton, NormalButton } from "@shared/designSystem/Button";
import { HorizontalContainer, VerticalContainer } from "@shared/designSystem/Containers";
import { Modal } from "@shared/designSystem/messages/Modal";
import { Text } from "@shared/designSystem/Texts";
import designSystemStyles from "@shared/styles/designSystemStyles";

interface DeleteQontactPointModalProps {
    isOpen: boolean;
    qontactPointName: string;
    onClose: () => void;
    /** Deletes the qontact point; the modal shows a loading state until it resolves */
    onConfirm: () => Promise<void>;
}

/**
 * "¿Eliminar este Qontact Point?" confirmation (design 4b). Used from the list and
 * from the Información tab. Deleting removes its shifts; past check-ins are kept.
 */
export const DeleteQontactPointModal: React.FC<DeleteQontactPointModalProps> = ({
    isOpen,
    qontactPointName,
    onClose,
    onConfirm,
}) => {
    const [isDeleting, setIsDeleting] = useState(false);

    const handleConfirm = async () => {
        if (isDeleting) {
            return;
        }
        setIsDeleting(true);
        try {
            await onConfirm();
        } finally {
            setIsDeleting(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={isDeleting ? () => {} : onClose}
            title={"¿Eliminar este Qontact Point?".localized()}
            width="520px"
            maxWidth="94vw"
        >
            <VerticalContainer width="100%" gap={designSystemStyles.gapLg}>
                <VerticalContainer width="100%" gap={designSystemStyles.gapSm}>
                    <Text text={"Se eliminará **%s**.".localized(qontactPointName.trim())} markdown={true} />
                    <Text
                        text={"Los colaboradores ya no podrán fichar en este lugar y se eliminan sus turnos. Los fichajes ya registrados se conservan. Esta acción no se puede deshacer.".localized()}
                        color={designSystemStyles.colorTextSecondary}
                    />
                </VerticalContainer>
                <HorizontalContainer width="100%" justifyContent="flex-end" gap={designSystemStyles.gapSm}>
                    <HollowedButton
                        text={"Cancelar".localized()}
                        onClick={onClose}
                        width="160px"
                        disabled={isDeleting}
                    />
                    <NormalButton
                        text={"Eliminar".localized()}
                        onClick={handleConfirm}
                        width="160px"
                        loading={isDeleting}
                        disabled={isDeleting}
                    />
                </HorizontalContainer>
            </VerticalContainer>
        </Modal>
    );
};

export default DeleteQontactPointModal;
